import {Component, Input, ChangeDetectionStrategy} from '@angular/core';
import {
  DangerInformation,
  Exemption_6_4,
  Vessel,
} from '@portbase/bezoekschip-service-typescriptmodels';
import {ExemptionBaseComponent} from "../../common/exemption_base/exemption_base.component";
import {PortvisitUtils} from "../../../../../refdata/portvisit-utils";
import {sendQuery} from "../../../../../common/utils";

@Component({
    selector: 'app-visit-exemptions-exemption-6-4',
    templateUrl: './exemption_6_4.component.html',
    styleUrls: ['./exemption_6_4.component.css'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class Exemption_6_4Component extends ExemptionBaseComponent {

  @Input() exemption: Exemption_6_4;

  portVisitUtils = PortvisitUtils;
  dangerousGoods?: DangerInformation;

  firstVessel: Vessel;
  secondVessel: Vessel;
  thirdVessel: Vessel;

  BUOY_MOORING = 'Buoy mooring';
  POLE_BERTHING = 'Pole berthing';

  searchVessel = term => sendQuery('com.portbase.bezoekschip.common.api.visit.FindVessels', {term: term});

  berthTypes: string[] = ['',
    'Quay',
    this.BUOY_MOORING,
    this.POLE_BERTHING
  ];

  vesselPrefixes: string[] = [
    '1st',
    '2nd',
    '3rd'
  ];

  shipLabelTooltip: string = 'vessel name receiving cargo being pumped over';

  ngOnInit(): void {
    if (!this.exemption.vessels) {
      this.exemption.vessels = [];
    }
  }
}
